
import toast  from './toast'
import makeguide  from './makeguide'

// 这里是重点
const install = function(Vue, opts = {}) {
    if (install.installed) return

    // Object.keys(wview).forEach(key => {
    //     Vue.component(key, wview[key]);
    // })

    Vue.prototype.$toast = toast.install
    Vue.prototype.$makeguide = makeguide.install
}

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

// 导出组件
export default {
    install,
}